import { makeStyles, Theme, Grid } from "@material-ui/core";
import { ConfirmationButton, createDateField, createPercentageField, createRadioField, createTextField, CurrencyField, DateField, trueFalseOptions } from "@roc/ui";
import { GenerateCemaStore } from "libs/feature-payoffs/stores/generateCemaStore";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({
  formFields: {
    marginTop: '1rem',
  },
  recalculate: {
    marginTop: '2rem',
  },
  radioField: {
    paddingLeft: '10px',
  },
}));

interface Props {
  store: GenerateCemaStore;
}

export const GenerateCema = observer(({ store }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <Grid container direction="row" justify="space-around">
        <Grid container xs={7}>
          <Grid item xs={6} className={classes.formFields}>
            {createRadioField({
              store,
              testId: 'newLenderMERS',
              fieldName: 'newLenderMERS',
              label: 'New Lender MERS?',
              options: trueFalseOptions,
              row: true,
            })}
          </Grid>
          <Grid item xs={6} className={classes.formFields}>
            {createRadioField({
              store,
              testId: 'oldLenderMERS',
              fieldName: 'oldLenderMERS',
              label: 'Old Lender MERS?',
              options: trueFalseOptions,
              row: true,
            })}
          </Grid>
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'New Lender Name',
            fieldName: 'newLenderName',
            testId: 'newLenderName',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'New Lender Address',
            fieldName: 'newLenderAddress',
            testId: 'newLenderAddress',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'Old Lender',
            fieldName: 'oldLender',
            testId: 'oldLender',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createRadioField({
            store,
            testId: 'buildingMortgage',
            fieldName: 'buildingMortgage',
            label: 'Building Mortgage?',
            options: trueFalseOptions,
            row: true,
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'New Lender Attorney',
            fieldName: 'newLenderAttorney',
            testId: 'newLenderAttorney',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'New Lender Mortgagee Clause',
            fieldName: 'newLenderMortgageeClause',
            testId: 'newLenderMortgageeClause',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createDateField({
              store,
              testId: 'recordedDate',
              label: 'Recorded Date',
              fieldName: 'recordedDate',
            })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createDateField({
              store,
              testId: 'recordedDateBuilding',
              label: 'Recorded Date (Building)',
              fieldName: 'recordedDateBuilding',
            })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createDateField({
              store,
              testId: 'recordedDocDate',
              label: 'Document Date',
              fieldName: 'recordedDocDate',
            })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'Recorded County',
            fieldName: 'recordedCounty',
            testId: 'recordedCounty',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'Recorded Doc Info',
            fieldName: 'recordedDocInformation',
            testId: 'recordedDocInformation',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'Recorded Doc Info (Building)',
            fieldName: 'recordedDocInformationBuilding',
            testId: 'recordedDocInformationBuilding',
          })}
        </Grid>
      </Grid>
    </div>
  );
});
